<div class="d-flex align-items-center">
  <mat-icon [ngStyle]="{ color: data.color }">{{ data.icon }}</mat-icon>
  <span>{{ data.message }}</span>
</div>
